import React, { memo } from 'react';
import Text from '../Text';

import {
  Label,
  Input,
  Check,
  Contain,
  RadioDisplay
} from './Styled';

const RadioButton = memo(({
  name,
  value,
  label,
  onClick,
  disabled,
  onChange,
  checked = false
}) => {
  return (
    <Contain onClick={() => !disabled && onClick(value)}>
      <Input
        readOnly
        type='checkbox'
        value={name}
        disabled={disabled}
        checked={checked}
      />
      <RadioDisplay checked={checked}>
        <Check checked={checked} />
      </RadioDisplay>
      <Label>
        <Text.Default size={'18px'} color={'rgb(1,52,83)'}>{label}</Text.Default>
      </Label>
    </Contain>
  );
});

export default RadioButton;
